/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Reset_ButtonInputs */

const en_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const fr_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const de_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const it_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const ru_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const es_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const zh_cn2_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const ja_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const hi_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

const pt_pt2_explorer_search_reset_button = /** @type {(inputs: Explorer_Search_Reset_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset`)
};

/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Explorer_Search_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_reset_button = /** @type {((inputs?: Explorer_Search_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_reset_button(inputs)
	if (locale === "de") return de_explorer_search_reset_button(inputs)
	if (locale === "it") return it_explorer_search_reset_button(inputs)
	if (locale === "ru") return ru_explorer_search_reset_button(inputs)
	if (locale === "es") return es_explorer_search_reset_button(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_reset_button(inputs)
	if (locale === "ja") return ja_explorer_search_reset_button(inputs)
	if (locale === "hi") return hi_explorer_search_reset_button(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_reset_button(inputs)
	return en_explorer_search_reset_button(inputs)
});